<template>
  <div class="publish-course" id="publish-course">
    <el-form
      ref="basicCourseForm"
      :model="basicCourseForm"
      label-position="left"
      label-width="200px"
      :rules="rules"
    >
      <div class="main-title">Basic Information</div>

      <el-form-item label="Course Title" prop="courseName">
        <el-input
          class="item-input_w60"
          placeholder="Course Title"
          v-model="basicCourseForm.courseName"
        ></el-input>
      </el-form-item>

      <!-- <el-form-item label="School Course ID" prop="courseNo">
                <el-input class="item-input_w60" placeholder="School Course ID" v-model="basicCourseForm.courseNo"></el-input>
            </el-form-item> -->

      <el-form-item label="Course Type" prop="tempCourseType">
        <!-- <el-select class="item-input_w20" placeholder="Course Type" v-model="basicCourseForm.tempCourseType">
                    <el-option v-for="item,index in courseList" :key="index" :value="item.id" :label="item.name">
                        {{item.name}}
                    </el-option>
                </el-select> -->

        <el-cascader
          placeholder="Select course type"
          class="item-input_w25"
          v-model="basicCourseForm.tempCourseType"
          :props="{
            value: 'id',
            label: 'name',
            checkStrictly: true,
            leaf: 'parent_id',
          }"
          :options="courseList"
        >
        </el-cascader>
      </el-form-item>

      <el-form-item label="Course Description" prop="courseDesc">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="Course Description"
          v-model="basicCourseForm.courseDesc"
        ></el-input>
      </el-form-item>

      <el-form-item label="Course Images">
        <el-upload
          ref="course-imgs-upload"
          :file-list="tempCourseImg"
          v-loading="loadingImg"
          class="my-image-uploader"
          list-type="picture-card"
          :on-preview="handleImgPreview"
          :accept="imgRules"
          :headers="{ 'x-covey-token': xToken }"
          :limit="3"
          multiple
          :on-exceed="handleImgExceed"
          :before-upload="beforeImgUpload"
          :on-success="handleImgSuccess"
          :on-error="handleImgUploadError"
          :action="getUploadImg + '?ts=' + Date.now()"
        >
          <i class="el-icon-circle-plus"></i>
          <span>Add Images</span>
        </el-upload>
      </el-form-item>

      <el-form-item label="Course Video">
        <div class="video-upload_box">
          <el-upload
            v-if="!this.basicCourseForm.courseVideo"
            v-loading="loadingvideo"
            class="video-upload_box"
            :accept="videoRules"
            :headers="{ 'x-covey-token': xToken }"
            :limit="1"
            :before-upload="beforeVideoUpload"
            :on-success="handleVideoSuccess"
            :on-error="handleVideoUploadError"
            :show-file-list="false"
            :action="getUploadImg + '?ts=' + Date.now()"
          >
            <i class="el-icon-circle-plus"></i>
            <span>Add Video</span>
          </el-upload>
          <div v-if="this.basicCourseForm.courseVideo" class="video-player-box">
            <i class="el-icon-close" @click="onRemoveVideo"></i>
            <videoPlayer
              ref="videoPlayer"
              :options="videoOption"
              :playsinline="true"
            >
            </videoPlayer>
          </div>
        </div>
      </el-form-item>
      <div class="main-title">Pricing and Packaging</div>

      <el-form-item label="Regular Price" prop="price">
        <el-input-number
          style="width: 20%"
          class="number-input"
          :controls="false"
          :precision="2"
          v-model="basicCourseForm.price"
        >
        </el-input-number>
        / Session (1 hour)
      </el-form-item>

      <el-form-item label="Bundle Options" prop="prices">
        <div
          v-for="(item, index) in basicCourseForm.prices"
          :key="index"
          style="margin-bottom: 24px"
        >
          <el-input-number
            :precision="0"
            :controls="false"
            style="width: 10%"
            v-model="item.book_amount"
            class="number-input"
            :min="minLesson(index)"
          ></el-input-number>
          Lesson
          <el-input-number
            :precision="2"
            :controls="false"
            style="width: 10%"
            v-model="item.price"
            class="number-input"
          ></el-input-number>
          / Session (1 hour)
          <i
            style="
              color: #f48c06;
              font-size: 16px;
              margin-left: 18px;
              cursor: pointer;
            "
            class="el-icon-delete"
            @click="deleteBundleOptions(index)"
          ></i>
        </div>
        <div class="icon-gray-button" @click="addBundleOptions">
          <img
            style="width: 20px; height: 20px"
            :src="require('@/assets/icon/coupon.png')"
          />
          <div>Add Bundle Options</div>
          <i class="el-icon-circle-plus"></i>
        </div>
      </el-form-item>

      <!-- <el-popover popper-class="schedule-popover" id="my-schedule-popover" trigger="manual" placement="right" v-model="showPopover"> -->

      <div class="main-title">Time Slot</div>
      <ScheduleTable
        ref="scheduleTable"
        @TempSchedule="onTempScheduleChange"
      ></ScheduleTable>

      <div class="main-title">Qualifications</div>

      <div class="qualifications-box">
        <div
          v-for="(item, index) in qualifications"
          :key="index"
          class="qualifications-item"
        >
          <el-form-item label="Qualifications">
            <el-input
              placeholder="Qualifications"
              v-model="item.qualification"
            ></el-input>
          </el-form-item>

          <el-form-item label="Institution">
            <el-input
              placeholder="Institution"
              v-model="item.institution"
            ></el-input>
          </el-form-item>
          <el-form-item label="Year of Issue">
            <el-date-picker
              type="year"
              placeholder="Year of Issue"
              v-model="item.issuetime"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Uploading the certification" style="margin: 0">
            <el-upload
              ref="qualifications_img"
              class="single-img_upload"
              v-loading="item.loading"
              :accept="imgRules"
              :headers="{ 'x-covey-token': xToken }"
              :limit="1"
              :show-file-list="false"
              :before-upload="(file) => beforeImgUpload(file, index)"
              :on-success="(response) => handleQualiImgSuccess(response, index)"
              :on-error="(res) => handleImgUploadError(res, index)"
              :action="getUploadImg + '?ts=' + Date.now()"
            >
              <div
                class="upload-icon"
                :style="{
                  'background-image':
                    'url(' + qualifications[index].certification_img + ')',
                  'border-color': qualifications[index].certification_img
                    ? 'transparent'
                    : '#DCDFE6',
                }"
              >
                <i
                  v-if="!qualifications[index].certification_img"
                  class="el-icon-circle-plus"
                ></i>
                <span v-if="!qualifications[index].certification_img"
                  >Add Image</span
                >
              </div>
            </el-upload>
          </el-form-item>
          <i
            class="el-icon-close close-qualifications"
            @click="deleteQualificationItem(index)"
          ></i>
        </div>
      </div>

      <el-form-item label="">
        <div class="icon-gray-button" @click="addQualifications">
          <img :src="require('@/assets/icon/coupon.png')" />
          <div>Qualifications</div>
          <i class="el-icon-circle-plus"></i>
        </div>
      </el-form-item>

      <el-form-item prop="groupId">
        <el-checkbox
          slot="label"
          v-model="basicCourseForm.isTeachingForAclub"
          @change="onTeachingForAclub"
          >Teaching for a club</el-checkbox
        >
        <el-select
          v-model="basicCourseForm.groupId"
          v-if="basicCourseForm.isTeachingForAclub"
          placeholder="Club"
        >
          <el-option
            v-for="(item, index) in getshortgroupList"
            :key="index"
            :value="item.covey_group.id"
            :label="item.covey_group.societyName"
            >{{ item.covey_group.societyName }}</el-option
          >
        </el-select>
        <span v-if="basicCourseForm.isTeachingForAclub">
          Share
          <el-input-number
            v-model="basicCourseForm.proportion"
            controls-position="right"
            style="height: 48px"
            :min="0"
            :max="100"
          ></el-input-number>
          % proportion for Club
        </span>
      </el-form-item>
      <div class="school-label">
        to which school(s) you want this course to be presented:
      </div>
      <el-form-item class="schoolId" prop="schoolId">
        <div>
          <el-checkbox-group v-model="schoolLabelList" @change="schoolChange">
            <el-checkbox
              v-for="(item, index) in schoolList"
              :label="item.name"
              :key="index"
            ></el-checkbox>
          </el-checkbox-group>
        </div>
      </el-form-item>
    </el-form>
    <div class="box-foot">
      <el-button
        class="my-button cancel"
        @click="handleSaveasDraft"
        :loading="draftLoading"
        >Save as draft</el-button
      >
      <el-button
        class="my-button"
        @click="handlePublishCourse"
        :loading="pubLoading"
        >Sure</el-button
      >
    </div>
    <el-dialog class="image-preview-dialog" :visible.sync="dialogVisible">
      <img
        style="width: 100%"
        class="image-preview"
        :src="dialogImageUrl"
        alt=""
      />
    </el-dialog>
  </div>
</template>

<script>
// import { format,validateObjAllProp } from '@/utils/comm';
import { mapState, mapGetters } from "vuex";
import ScheduleTable from "@/views/Pc/Component/ScheduleTable";
import ValidateButton from "@/views/Pc/Component/ValidateButton";
import _ from "lodash";
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import { determineArrOrder } from "@/utils/comm";
export default {
  components: {
    ScheduleTable,
    ValidateButton,
    videoPlayer,
  },
  computed: {
    ...mapState({
      xToken: (state) => state.app.token,
      navTree: (state) => state.menu.navTree,
    }),
    ...mapGetters(["getUploadImg"]),
  },
  mounted() {
    this.getCourseType();
    if (this.$route.query.draftId) {
      this.initDraft();
    }
    this.getSchoolList();
  },
  created() {},
  data() {
    let priceValidator = function (rule, value, callback) {
      if (value <= 0.0) {
        callback(new Error("Please fill in the correct price"));
      } else {
        callback();
      }
    };
    let pricesValidator = function (rule, value, callback) {
      let validateNumber = function (val) {
        if (typeof val === "number" && !isNaN(val) && val > 0) {
          return true;
        } else {
          return false;
        }
      };
      for (let priceItem of value) {
        if (
          !validateNumber(priceItem.book_amount) ||
          !validateNumber(priceItem.price)
        ) {
          callback(new Error("Please fill in the correct amount and price"));
          break;
        }
      }
      callback();
    };
    return {
      loadingImg: false,
      loadingvideo: false,
      dialogVisible: false,
      dialogImageUrl: "",
      courseList: [],
      basicCourseForm: {
        courseName: "", //课程名
        courseNo: "", //课程代号
        tempCourseType: [], //课程分类

        FathercourseType: null, //父级id
        courseType: null, //子级id

        courseImg: [],
        courseVideo: "", //
        courseDesc: "", //课程描述
        price: "", //Regular Price
        prices: [],

        calendars: [], //课表相关
        isTeachingForAclub: false,
        groupId: "", //社团id默认值
        proportion: 50, //社团分成默认值
        schoolId: "",
      },
      imgRules: "image/png , image/jpeg",
      videoRules: "video/mp4 , video/flv , video/avi",
      qualifications: [
        {
          qualification: "",
          institution: "",
          issuetime: "",
          certification_img: "",
          loading: false,
        },
      ], //证书

      showPopover: true,
      isRepeatDate: false,
      repeatDate: {
        isRepeatDate: false,
        repeatType: 0,
        limitType: 0,
        times: 0,
        closingDate: "",
      },
      scheduleData: [],
      draftLoading: false,
      pubLoading: false,
      tempCourseImg: [], //临时保存 回显图片

      rules: {
        courseName: [
          {
            required: true,
            message: "Please fill in the course title.",
            trigger: "blur",
          },
        ],
        // courseNo: [
        //     {
        //         required: true,
        //         message: "Please fill in the course ID.",
        //         trigger: "blur",
        //     }
        // ],
        tempCourseType: [
          {
            required: true,
            message: "Please select the course type.",
            trigger: "blur",
          },
        ],
        courseDesc: [
          {
            required: true,
            message: "Please fill in the course profile.",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: true,
            validator: priceValidator,
            trigger: "blur",
          },
        ],
        prices: [
          {
            required: true,
            validator: pricesValidator,
            trigger: "blur",
          },
        ],
        groupId: [
          {
            validator: this.validateGroupId,
            trigger: "blur",
          },
        ],
      },
      getshortgroupList: [], //社团

      qualiImgLoading: false,
      videoOption: {
        playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
        autoplay: false, // 如果为true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 是否视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", // 类型
            src: "", // url地址
          },
        ],
        poster: "", // 封面地址
        notSupportedMessage: "System Error", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true, // 当前时间和持续时间的分隔符
          durationDisplay: true, // 显示持续时间
          remainingTimeDisplay: false, // 是否显示剩余时间功能
          fullscreenToggle: true, // 是否显示全屏按钮
        },
      }, //课程视频参数
      schoolList: [],
      schoolLabelList: [],
    };
  },
  methods: {
    //获取学校下拉列表
    getSchoolList() {
      this.$api.courseApi.getSchoolList().then((res) => {
        if (res.status === "0") {
          this.schoolList = res.data.rows;

          // for (let item of this.schoolList) {
          //   if (this.schoolId === item.id) {
          //     this.schoolName = item.name;
          //     break;
          //   }
          // }
        }
      });
    },
    schoolChange(val) {
      let schoolIdStr = "";
      for (let item of val) {
        for (let j of this.schoolList) {
          if (item === j.name) {
            schoolIdStr += j.id + "#";
            break;
          }
        }
      }
      this.basicCourseForm.schoolId = schoolIdStr;
    },
    validateNumber(val) {
      if (typeof val === "number" && !isNaN(val) && val > 0) {
        return true;
      } else {
        return false;
      }
    },
    //使修改多次课程时数量保持递增
    minLesson(index) {
      if (this.basicCourseForm.prices[index - 1]) {
        return this.basicCourseForm.prices[index - 1].book_amount + 1;
      } else {
        return 2;
      }
    },
    handleImgPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    deleteBundleOptions(index) {
      this.basicCourseForm.prices.splice(index, 1);
    },
    validateGroupId(rule, value, callback) {
      if (this.basicCourseForm.isTeachingForAclub) {
        if (value === "") {
          callback(new Error("Please select a club"));
        } else {
          callback();
        }
      }
      callback();
    },
    //如果有带draftId 则为草稿
    initDraft() {
      this.getshortgroup();
      this.$api.courseApi
        .getTeacherCourseList({ id: this.$route.query.draftId })
        .then((res) => {
          if (res.status === "0") {
            let course = res.data.rows[0];
            this.basicCourseForm.courseName = course.courseName;
            // this.basicCourseForm.courseNo = course.courseNo;
            let t = [];
            if (course.FathercourseType) {
              t.push(course.FathercourseType);
            }
            if (
              course.courseType &&
              course.courseType !== course.FathercourseType
            ) {
              t.push(course.courseType);
            }
            this.$set(this.basicCourseForm, "tempCourseType", t);

            this.basicCourseForm.FathercourseType = course.FathercourseType;
            this.basicCourseForm.courseType = course.courseType;

            this.basicCourseForm.courseImg = JSON.parse(course.courseImg || []);
            for (let item of this.basicCourseForm.courseImg) {
              //回显课程图片
              this.tempCourseImg.push({
                name: item,
                url: item,
                hasUploaded: 1,
              });
            }
            this.basicCourseForm.courseVideo = course.courseVideo;
            this.basicCourseForm.courseDesc = course.courseDesc;

            this.basicCourseForm.groupId = course.groupId;
            this.basicCourseForm.proportion = course.proportion;
            this.basicCourseForm.isTeachingForAclub =
              this.basicCourseForm.groupId === 0 ? false : true;
            // this.basicCourseForm.price = (course.price/100).toFixed(2);

            this.videoOption.sources[0].src = course.courseVideo;
            this.qualifications = JSON.parse(course.certifications);
            let schoolIds = course.schoolId.split("#");
            schoolIds.pop();
            this.schoolLabelList = [];
            for (let item of schoolIds) {
              for (let j of this.schoolList) {
                if (parseInt(item) === j.id) {
                  this.schoolLabelList.push(j.name);
                  break;
                }
              }
            }
            this.schoolChange(this.schoolLabelList);
          }
        })
        .then(() => {
          this.getCoursePrice(this.$route.query.draftId);
        });
    },
    //重新发布课程时 获取该课程的价格信息
    getCoursePrice(courseId) {
      this.$api.courseApi.getCoursePrice({ courseId: courseId }).then((res) => {
        if (res.status === "0") {
          if (Array.isArray(res.data) && res.data.length > 0) {
            this.basicCourseForm.price = (res.data[0].price / 100).toFixed(2);
          } else {
            this.basicCourseForm.price = 0;
          }
          let tempData = [...res.data];
          tempData.shift();
          for (let item of tempData) {
            item.price = (item.price / 100).toFixed(2);
          }
          this.basicCourseForm.prices = tempData;
        } else {
          this.$message.error("Error!" + res.message);
        }
      });
    },
    // 获取社团列表
    getshortgroup() {
      this.$api.courseApi.getshortgroup().then((res) => {
        if (res.status === "0") {
          this.getshortgroupList = res.data.rows;
          if (Array.isArray(res.data.rows) && res.data.rows.length === 0) {
            //todo 未加入社团的情况
            this.$message.warning("Not yet joined the club");
            this.basicCourseForm.isTeachingForAclub = false;
          }
        }
      });
    },
    onTeachingForAclub(val) {
      if (val) {
        this.basicCourseForm.groupId = "";
        this.getshortgroup();
      }
    },
    //过滤courseType
    filterCourse(data) {
      if (!data) return;
      for (let item of data) {
        if (Array.isArray(item.children) && item.children.length === 0) {
          delete item.children;
        }
        this.filterCourse(item.children);
      }
    },
    //获取学校下拉列表
    getCourseType() {
      this.$api.courseApi.getCourseType().then((res) => {
        if (res.status === "0") {
          let t_data = res.data;
          this.filterCourse(t_data);
          this.courseList = res.data;
        }
      });
    },
    deleteQualificationItem(index) {
      this.qualifications.splice(index, 1);
    },
    //***上传图片****/

    //上传文件检查
    beforeImgUpload(file, index) {
      const isImage = this.imgRules.includes(file.type);
      const isLt20M = file.size / 1024 / 1024 <= 5;
      if (!isImage) {
        this.$message.error(
          "Only upload pictures in PNG/JPG format is supported."
        );
        return isImage && isLt20M;
      }
      if (!isLt20M) {
        this.$message.error("Upload picture size cannot exceed 5MB.");
        return isImage && isLt20M;
      }
      if (index !== undefined) {
        this.$set(this.qualifications[index], "loading", true);
      }

      return isImage && isLt20M;
    },
    //文件个数超出限制
    handleImgExceed(files, fileList) {
      this.$message.error("Up to three photos can be uploaded");
    },
    //上传成功获取上传图片地址
    async handleImgSuccess(res, file, fileList) {
      if (res.status !== "0") {
        this.$message.error(`${file.name} ERROR! Reason : ${res.message}`);
      }
    },

    //上传成功获取上传图片地址 --- 证书
    async handleQualiImgSuccess(res, index) {
      if (res.status !== "0") {
        this.$message.error(`ERROR! Reason : ${res.message}`);
      } else {
        this.$set(this.qualifications[index], "loading", false);
        this.qualifications[index].certification_img = res.data;
      }
    },
    //删除
    handleQualiImgRemove(file, fileList, index) {
      this.$set(this.qualifications[index], "certification_img", "");
    },

    //上传失败
    handleImgUploadError(err, index) {
      this.$message.error(err);
      if (index !== undefined) {
        this.qualifications[index].loading = false;
      }
    },
    //***上传视频****/
    //删除视频
    onRemoveVideo() {
      this.basicCourseForm.courseVideo = "";
    },
    //上传文件检查
    beforeVideoUpload(file) {
      const isImage = this.videoRules.includes(file.type);
      const isLt20M = file.size / 1024 / 1024 <= 20;
      if (!isImage) {
        this.$message.error(
          "Only upload Video in mp4/flv/avi format is supported."
        );
        return isImage && isLt20M;
      }
      if (!isLt20M) {
        this.$message.error("Upload video size cannot exceed 20MB.");
        return isImage && isLt20M;
      }
      this.loadingvideo = true;
      return isImage && isLt20M;
    },
    //上传成功获取上传图片地址
    async handleVideoSuccess(res, file, fileList) {
      if (res.status === "0") {
        this.$message.success("SUCCESS!");
        this.basicCourseForm.courseVideo = res.data;
      } else {
        this.$message.error(`${file.name} ERROR! Reason : ${res.message}`);
      }
      this.videoOption.sources[0].src = res.data;
      this.loadingvideo = false;
    },
    //上传失败
    handleVideoUploadError(err, file, fileList) {
      if (err) {
        this.$message.error(`${file.name} ERROR!`);
      }
    },
    //添加课程
    addBundleOptions() {
      this.basicCourseForm.prices.push({
        book_amount: 0,
        price: 0,
      });
    },
    //添加证书
    addQualifications() {
      if (this.qualifications.length >= 4) {
        return;
      }
      this.qualifications.push({
        qualification: "",
        institution: "",
        issuetime: "",
        certification_img: "",
        loading: false,
      });
    },
    onTempScheduleChange(data) {
      this.scheduleData = data;
    },
    handlePublishCourse() {
      this.$refs["basicCourseForm"].validate((valid) => {
        if (!valid) {
          this.$nextTick(() => {
            let isError = document.getElementsByClassName("is-error");
            isError[0].scrollIntoView({
              // 滚动到指定节点
              block: "center",
              behavior: "smooth",
            });
          });
          return;
        }

        this.basicCourseForm.courseImg = [];
        for (let item of this.$refs["course-imgs-upload"].uploadFiles) {
          if (item.hasUploaded && item.hasUploaded === 1) {
            //已经传过的就直接读取url  此处用hasUploaded作为标识
            this.basicCourseForm.courseImg.push(item.url);
            continue;
          }
          if (item.response && item.response.status === "0") {
            this.basicCourseForm.courseImg.push(item.response.data);
          } else {
            this.$message.error("The picture is being uploaded, please wait.");
            return;
          }
        }
        let params = _.cloneDeep(this.basicCourseForm);
        if (params.tempCourseType.length === 1) {
          params.FathercourseType = params.tempCourseType[0];
          params.courseType = params.tempCourseType[0];
        } else if (params.tempCourseType.length === 2) {
          params.FathercourseType = params.tempCourseType[0];
          params.courseType = params.tempCourseType[1];
        }
        delete params.tempCourseType;
        params.price = params.price * 100; //价格乘以100

        params.prices.unshift({
          book_amount: 1,
          price: this.basicCourseForm.price,
        });
        // params.prices.forEach((item) => {
        //   item.price = item.price * 100;
        // });
        if (params.prices.length < 1) {
          this.$message.warning(
            "Please fill at least one correct amount and one price in Bundle Options"
          );
          return;
        }
        for (let priceItem of params.prices) {
          if (
            !this.validateNumber(priceItem.book_amount) ||
            !this.validateNumber(priceItem.price)
          ) {
            this.$message.warning(
              "Please fill in the correct amount and price in Bundle Options"
            );
            return;
          } else {
            priceItem["price"] = priceItem.price * 100;
          }
        }

        //prices 有两项
        if (params.prices.length >= 2) {
          let bookAmountArr = params.prices.map((item) => item.book_amount);
          let priceArr = params.prices.map((item) => item.price);
          if (
            determineArrOrder(bookAmountArr) !== "ascending" ||
            determineArrOrder(priceArr) !== "descending"
          ) {
            this.$message.warning(
              "Amoun must increase, price must decrease in Bundle Options"
            );
            return;
          }
        }

        params.calendars = this.scheduleData;

        params.certifications = _.cloneDeep(this.qualifications);
        for (let item of params.certifications) {
          delete item.loading;
        }
        //处理社团
        if (!params.isTeachingForAclub) {
          //不加社团
          params.groupId = 0;
          params.proportion = 0;
        }
        //学校
        if (!params.schoolId) {
          this.$message.warning("Please select at least one school");
          return;
        }
        delete params.isTeachingForAclub;
        if (this.$route.query.draftId) {
          params.id = parseInt(this.$route.query.draftId);
        }
        this.pubLoading = true;
        this.$api.courseApi
          .applyCourse(params)
          .then((res) => {
            if (res.status === "0") {
              this.$alert(
                "The course was published successfully. Please wait for approval!",
                "Info",
                {
                  confirmButtonText: "Sure",
                  type: "success",
                  center: true,
                }
              );

              this.$refs["basicCourseForm"].resetFields();
              this.$router.push({ path: "/teach/courses" });
            } else {
              this.$message.error("ERROR! REASON : " + res.message);
            }
            this.pubLoading = false;
          })
          .catch((err) => {
            this.pubLoading = false;
          });
      });
    },
    validateNumber(val) {
      if (typeof val === "number" && !isNaN(val) && val > 0) {
        return true;
      } else {
        return false;
      }
    },
    handleSaveasDraft() {
      //存草稿
      this.basicCourseForm.courseImg = [];
      for (let item of this.$refs["course-imgs-upload"].uploadFiles) {
        if (item.hasUploaded && item.hasUploaded === 1) {
          //已经传过的就直接读取url  此处用hasUploaded作为标识
          this.basicCourseForm.courseImg.push(item.url);
          continue;
        }
        if (item.response && item.response.status === "0") {
          this.basicCourseForm.courseImg.push(item.response.data);
        } else {
          this.$message.warning("The picture is being uploaded, please wait.");
          return;
        }
      }

      let params = _.cloneDeep(this.basicCourseForm);
      if (!params.courseName) {
        this.$notify({
          type: "error",
          message: "Please fill in the course name.",
          position: "bottom-right",
        });
        return;
      }
      if (params.tempCourseType.length === 1) {
        params.FathercourseType = params.tempCourseType[0];
        params.courseType = params.tempCourseType[0];
      } else if (params.tempCourseType.length === 2) {
        params.FathercourseType = params.tempCourseType[0];
        params.courseType = params.tempCourseType[1];
      }
      delete params.tempCourseType;
      params.price = params.price * 100; //价格乘以100

      params.prices.unshift({
        book_amount: 1,
        price: this.basicCourseForm.price,
      });
      if (params.prices.length < 1) {
        this.$message.warning(
          "Please fill at least one correct amount and one price in Bundle Options"
        );
        return;
      }
      for (let priceItem of params.prices) {
        if (
          !this.validateNumber(priceItem.book_amount) ||
          !this.validateNumber(priceItem.price)
        ) {
          this.$message.warning(
            "Please fill in the correct amount and price in Bundle Options"
          );
          return;
        } else {
          priceItem["price"] = priceItem.price * 100;
        }
      }

      //prices 有两项
      if (params.prices.length >= 2) {
        let bookAmountArr = params.prices.map((item) => item.book_amount);
        let priceArr = params.prices.map((item) => item.price);
        if (
          determineArrOrder(bookAmountArr) !== "ascending" ||
          determineArrOrder(priceArr) !== "descending"
        ) {
          this.$message.warning(
            "Amoun must increase, price must decrease in Bundle Options"
          );
          return;
        }
      }
      params.calendars = this.scheduleData;

      params.certifications = _.cloneDeep(this.qualifications);
      for (let item of params.certifications) {
        delete item.loading;
      }
      //处理社团
      if (!params.isTeachingForAclub) {
        params.groupId = 0;
        params.proportion = 0;
      } else {
        for (let item of this.getshortgroupList) {
          if (params.groupId === item.covey_group.id) {
            params.proportion = item.proportion;
            break;
          }
        }
      }
      delete params.isTeachingForAclub;
      params.isdraft = 1;
      if (this.$route.query.draftId) {
        params.id = this.$route.query.draftId;
      }
      this.draftLoading = true;
      this.$api.courseApi
        .savedraftCourse(params)
        .then((res) => {
          if (res.status === "0") {
            this.$message.success("Success!");
          } else {
            this.$message.error("ERROR! REASON : " + res.message);
          }
          this.draftLoading = false;
        })
        .catch((err) => {
          this.draftLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.publish-course,
* {
  font-family: "PingFangSC-Semibold", "PingFang SC";
}
/deep/ .el-textarea__inner {
  font-family: "PingFangSC-Semibold", "PingFang SC";
}
.publish-course {
  height: 100%;
  background: linear-gradient(207deg, #ffffff 0%, #ffffff 100%);
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 24px;
  box-sizing: border-box;

  .main-title {
    height: 30px;
    font-size: 24px;
    font-weight: 600;
    color: #201002;
    line-height: 30px;
    margin-bottom: vw(32);
  }
  .school-label {
    line-height: 24px;
    font-size: 14px;
    font-weight: 600;
    color: #201002;
  }
  .schoolId {
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
    /deep/ .el-form-item__label {
      width: auto !important;
    }
  }

  /deep/.el-form-item {
    .el-input-number__increase {
      line-height: 24px;
      border-top-right-radius: 8px;
    }
    .el-input-number.is-controls-right .el-input-number__decrease {
      line-height: 24px;
      border-bottom-right-radius: 8px;
    }
    .el-form-item__content {
      line-height: 48px;
    }
    .el-form-item__label {
      color: #201002;
      font-size: 14px;
      line-height: 48px;
    }

    .el-input__inner,
    .el-textarea__inner {
      border-radius: 8px;
      border: 1px solid rgba(32, 16, 2, 0.32);
    }

    .el-input__inner {
      height: 48px;
      line-height: 48px;
    }
    .item-input_w20 {
      width: 20%;
    }
    .item-input_w25 {
      width: 25%;
    }
    .item-input_w60 {
      width: 60%;
    }
    .my-image-uploader {
      display: flex;
      flex-direction: column;
      .el-upload-list--picture-card .el-upload-list__item {
        width: 240px;
        height: 144px;
      }
      .el-upload-list--picture-card {
        li {
          width: calc(20% - 6.4px);
          margin: 0 0 8px 0;
        }
        li:nth-child(n + 2) {
          margin: 0 0 8px 8px;
        }
        .el-upload-list__item {
          text-align: center;
        }
        .el-upload-list__item-thumbnail {
          width: auto;
        }
      }
    }
    .el-upload {
      width: 240px;
      height: 144px;
      background: #f7f6f6;
      border-radius: 8px;
      border: 1px dashed rgba(32, 16, 2, 0.32);
      cursor: pointer;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      color: #b7b2ae;
      font-weight: 600;
      i {
        color: #b7b2ae;
        font-size: 16px;
      }
      span {
        line-height: 20px;
      }
    }
    .single-img_upload {
    }
    .image-preview-dialog {
      .image-preview {
        height: 100%;
        width: 100%;
      }
    }
    .icon-gray-button {
      height: 20px;
      padding: 14px;
      background: rgba(32, 16, 2, 0.04);
      display: inline-block;
      position: relative;
      border-radius: 8px;
      cursor: pointer;
      img {
        display: inline-block;
        vertical-align: top;
      }
      div {
        display: inline-block;
        vertical-align: top;
        line-height: 20px;
        margin-left: 4px;
        font-size: 14px;
        font-weight: 600;
        color: #201002;
        margin-left: 4px;
      }
      i {
        margin-top: 3px;
        display: inline-block;
        vertical-align: top;
        font-size: 16px;
        top: 2px;
        margin-left: 14px;
      }
    }
    .number-input {
      .el-input__inner {
        text-align: left;
      }
    }
    .el-checkbox {
      color: #201002;
      font-size: 14px;
      line-height: 48px;
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      font-weight: 600;
      color: #201002;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: #201002;
      border-color: #201002;
    }
  }
  .qualifications-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 20px 0;

    .qualifications-item {
      position: relative;
      box-sizing: border-box;
      border-radius: 8px;
      padding: vw(12);
      width: 0;

      .close-qualifications {
        position: absolute;
        right: vw(12);
        top: vw(12);
        cursor: pointer;
        display: none;
      }
      &:hover {
        background: #f0f0f0;
        .close-qualifications {
          display: block;
        }
      }
      width: 50%;
      /deep/.el-upload {
        width: 100% !important;
      }
      /deep/.el-date-editor {
        width: 100%;
      }
    }
  }
  .time-slot-box {
    background: #ffffff;
    box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
    border-radius: 24px;
    padding: 40px 32px;
    box-sizing: border-box;

    margin-bottom: 56px;

    /deep/.el-table__header tr,
    .el-table__header th {
      padding: 0;
      height: 40px;
    }
    /deep/ .el-table__body tr,
    .el-table__body td {
      padding: 0;
      height: 48px;
    }
    /deep/ .el-table::before {
      height: 0px;
    }
    .time-slot-head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .now-date {
        height: 25px;
        font-size: 18px;
        font-weight: 600;
        color: #f48c06;
        line-height: 25px;
      }
      .time-operate {
        i {
          cursor: pointer;
        }
      }
    }
  }
  .box-foot {
    margin-top: 56px;
    text-align: right;
    font-size: 15px;
  }
  .my-button {
    cursor: pointer;
    height: 48px;
    background: #f48c06;
    border: none;
    border-radius: 8px;
    color: #fff;
    font-size: 15px;
    span {
      font-size: 15px;
      color: #ffffff;
      line-height: 20px;
    }
  }
  .cancel {
    // margin-right: 24px;
    background: #f2f2f2;
    color: #201002;
  }
  .upload-icon {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 8px;

    background-repeat: no-repeat;
    background-position: top center;
    background-size: contain;

    // border: 1px solid;
  }
  .video-upload_box {
    display: flex;
    position: relative;
    .el-upload-list {
      position: absolute;
    }
  }
  .video-player-box {
    box-sizing: border-box;
    border-radius: 8px;

    width: 240px;
    height: 144px;
    padding: 8px;
    background: #e6e6e6;
    position: relative;
    i {
      cursor: pointer;
      position: absolute;
      color: #000;
      font-size: 20px;
      position: absolute;
      right: -8px;
      top: -8px;
    }

    /deep/.video-js .vjs-big-play-button {
      width: 1.5em;
      border-radius: 50%;
      top: calc(50% - 0.75em);
      left: calc(50% - 0.75em);
    }
  }
}
</style>
